import React from "react";
import { connect } from "react-redux";
import { Link } from "@mui/material";
import type { Dispatch } from "redux";
import { bindActionCreators } from "redux";
import { setErrors, getErrors } from "@fas/ui-framework";
import ModifierForm from "../../components/ModifierForm";
import { getModifierFormData, getModifierFormIsExpand } from "../../selectors/modifierForm";
import { saveModifierFormSaga, setModifierFormFields, setModifierFormIsExpand } from "../../actions/modifierForm";
import type { State } from "../../pages/AppStoreWrapper";
import type { StateToProps, DispatchToProps, Props } from "./types/ModifierForm.type";

const mapStateToProps: (state: State) => StateToProps = (state) => ({
  modifier: getModifierFormData(state),
  isExpand: getModifierFormIsExpand(state),
  errors: getErrors(state).toJS(),
});

const mapDispatchToProps: (arg0: Dispatch<any>) => DispatchToProps = dispatch => ({
  ...bindActionCreators({
    onSetModifierForm: setModifierFormFields,
    onSetIsExpand: setModifierFormIsExpand,
    onSave: saveModifierFormSaga,
    onSetErrors: setErrors,
  }, dispatch),
});

function ModifierFormContainer({
  modifier,
  isExpand,
  errors,
  onSetModifierForm,
  onSetIsExpand,
  onSave,
  onSetErrors,
}: Props) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isExpand ? (
        <ModifierForm
          description={modifier.description}
          anchor={modifier.name}
          type={modifier.type}
          types={["input", "textarea", "html"]}
          errors={errors}
          onTypeChange={(value: string | null) => onSetModifierForm({ type: value?.toString() })}
          onDescriptionChange={(value: string | null) => onSetModifierForm({ description: value?.toString() })}
          onAnchorChange={(value: string | null) => onSetModifierForm({ name: value?.toString() })}
          onApply={() => onSave(modifier)}
          onCancel={() => {
            onSetModifierForm({
              name: "",
              description: "",
              type: "textarea",
            });
            onSetIsExpand(false);
            onSetErrors({});
          }}
        />
      ) : (
        <Link
          variant="button"
          component="button"
          onClick={() => onSetIsExpand(true)}
          data-testid="addNewButton"
        >
          + Add New Modifier for this template
        </Link>
      )}
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ModifierFormContainer);
